import { useState, useEffect } from "react";
import api from "../lib/api";
import { Loader2 } from "lucide-react";

export function AuthImage({ path, alt, className }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let url;
    let active = true;
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => setErr(true));
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (err) return <div className={`flex items-center justify-center bg-slate-100 text-slate-400 text-xs ${className}`}>No image</div>;
  if (!src) return <div className={`flex items-center justify-center bg-slate-100 ${className}`}><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>;
  return <img src={src} alt={alt} className={className} />;
}
